import React from 'react';
import styles from "./Star.module.css";
interface StarProps {
  value: number;
}
const Star: React.FC<StarProps> = ({
  value
}) => {
  return <span className={styles.star} data-sentry-component="Star" data-sentry-source-file="Star.tsx">
      <span className='text-white' style={{
      WebkitTextStroke: '2px #ff9f00'
    }}>★</span>
      <span className="absolute left-0 top-0 overflow-hidden text-[#ff9f00]" style={{
      width: `${value * 100}%`
      // WebkitTextStroke: '1px black'
    }}>
        ★
      </span>
    </span>;
};
export default Star;